import styled from "styled-components";

export const SideBoxInfo = styled.div`
  max-width: 560px;
  width:100%;
  position: absolute;
  margin-top: ${props => props.theme.margins.large};
  top: 0;
  bottom: 0;
  right: 0;
  overflow-y: hidden;
  background-color: ${props => props.theme.backgrounds.white};
  border-left: ${props => props.theme.border.small};


`;

export const MainContent = styled.div`
  display: flex;
  /* padding-top:56px; */
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y:auto;
  padding: 74px 1rem 1rem 1rem;
  align-items:center;

`;

export const WrapperTableItems = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;

  .td-text-end {
    text-align: end;
    justify-content: flex-end;
  }
`;

export const WrapperTotal = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  justify-content: flex-end;
  gap: 50px;
`;

export const WrapperTotalItems = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  justify-content: space-between;
  width: auto;
  /* position: fixed; */
  /* left: ${props => props?.left ?? 'auto'};
  right: ${props => props?.right ?? 'auto'}; */
`;



export const ContainerHours = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0 2rem 0;
  max-width: 50%;
`;

export const WrapperHourItems= styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
`;

export const WrapperItems= styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerButtonClient = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  
  .inform-client {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

`;

export const WrapperHours = styled.div`
  display: flex;
  background-color: red;
`;

export const WrapperImg = styled.div`
  width: 56px;
  max-width: 100%;
  border-radius: 20% ;
  overflow: hidden;
  img{
    width: 100%;
    height: 100%;

  }

`;

export const wrapperSelectedItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border: ${props => props.theme.border.very_small};
  border-radius: 8px;
  padding: 10px;

  :focus{
    border: ${props => props.theme.border.very_small_red2}
  }

`;

export const items = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .click{
    cursor: pointer;
  }
`;